import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Col, Row } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import Flex from 'components/common/Flex';
import BarChartComponent from './AverageEnrollmentChart';
import { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment';

const SupportServicesLineDate = ({data,selectedYear}) => {


useEffect(()=>{
const xAxiasData=[];
const totalSupportCalls=[];
const resolved=[];
const temporaryResolved=[];
const permanentlyResolved=[];
const pending=[];

for(let i=0;i<data.length;i++){

  xAxiasData.push(data[i].month);
  totalSupportCalls.push(data[i].totalSupportCalls);
  resolved.push(data[i].resolved);
  temporaryResolved.push(data[i].temporaryResolved);
  permanentlyResolved.push(data[i].permanentlyResolved);
  pending.push(data[i].pending);
}
// "permanentlyResolved":0,"temporaryResolved":0,"pending":0
setChartData({...chartData,xAxisData:xAxiasData,totalSupportCalls,
  resolved,temporaryResolved,permanentlyResolved,pending})

},[data])
  const [chartData,setChartData] = useState({
    totalSupportCalls: [
    //   2000, 2800, 2200, 3001, 600, 600, 2000, 2000, 700, 1000, 200, 900, 1200,2000, 2800, 2200, 3001, 600, 600, 2000, 2000, 700
    ],
    resolved: [
      //   2000, 2800, 2200, 3001, 600, 600, 2000, 2000, 700, 1000, 200, 900, 1200,2000, 2800, 2200, 3001, 600, 600, 2000, 2000, 700
      ],
   seriesName: ['Total Support Calls','Resolved','Temporary Resolved','Permanently Resolved','Pending'],
   xAxisData:[
    // '1', // Start from 1 instead of 'launch'
    // '2', // 2 instead of 'week 1'
    // '3', // 3 instead of 'week 2'
    // '4', // 4 instead of 'week 3'
    // '5', // 5 instead of 'week 4'
  ],
  });

  const chartRef = useRef(null);

  const handleLegendToggle = (event, name) => {
    chartRef.current.getEchartsInstance().dispatchAction({
      type: 'legendToggleSelect',
      name
    });
    event.target.closest('button').classList.toggle('opacity-50');
  };

  return (
    <Card>

      <Card.Body className="pb-0">
      {/* {JSON.stringify(chartData)} */}
        <BarChartComponent
        data={chartData}
          ref={chartRef}
          style={{ 'min-height': '18.625rem', width: '100%' }}
        />
      </Card.Body>
    </Card>
  );
};


export default SupportServicesLineDate;
